import _fetch, { downBlob } from "./fetch"
import _Request from "./request"
import { netListener } from "./netListener"
import { cache } from "../index.web"

const request = new _Request({
  GET: _fetch.get,
  POST: _fetch.post,
  DELETE: _fetch.delete,
  PUT: _fetch.put,
  UPLOAD: _fetch.upload,
})

type ServiceCallConfig = {
  (serviceName: string): {
    params: { method?: string; params?: unknown; protocol?: string } | undefined
    tempEnv?: string
    getwayUrl?: string
  }
}
let serviceCallCfgFn: ServiceCallConfig[]
let serviceCallEnv = "prod"
let migrateConfig = {}

export const net = {
  init(
    serviceCallCfg: { getConfig: ServiceCallConfig, officialApi: any[] },
    _serviceCallEnv?: string,
    _migrateConfig?: any
  ) {
    if (!serviceCallCfgFn) serviceCallCfgFn = []
    serviceCallCfgFn.push(serviceCallCfg.getConfig)
    if (serviceCallCfg?.officialApi && serviceCallCfg?.officialApi.length) {
      cache.set('_officialApi_', JSON.stringify(serviceCallCfg.officialApi))
    }
    if (_serviceCallEnv) serviceCallEnv = _serviceCallEnv
    if (_migrateConfig) migrateConfig = _migrateConfig
  },

  config(
    config?: NetConfig,
    interceptor?: InitIntercept<NetRequest, NetResult<any>>
  ) {
    request.config(config, interceptor)
  },
  /**
   * GET请求
   * @param url 请求地址
   * @param config 配置
   */
  async get<T = any>(url: string, config?: NetConfig): Promise<NetResult<T>> {
    const { data = "" } = config || {}
    const result = await request.preSend({
      url,
      ...config,
      data,
      method: "GET",
    })
    return result
  },

  /**
   * POST请求
   * @param url 请求地址
   * @param config 配置
   */
  async post<T = any>(url: string, config?: NetConfig): Promise<NetResult<T>> {
    const { data = {} } = config || {}
    const result = await request.preSend({
      url,
      ...config,
      data,
      method: "POST",
    })
    return result
  },

  /**
   * @param url 请求地址
   * @param config 配置
   */
  async request<T = any>(
    url: string,
    config?: NetConfig & { type?: "GET" | "POST" }
  ): Promise<NetResult<T>> {
    if (config?.type == "GET") {
      return net.get(url, config)
    }
    return net.post(url, config)
  },
  /**
   * 上传
   * @param url 请求地址
   * @param config 配置
   */
  async upload<T = any>(
    url: string,
    config?: NetConfig & {
      method?: string
      fileList?: any[]
      formData?: any
    }
  ): Promise<NetResult<T>> {
    const result = await request.preSend({ url, ...config, method: "UPLOAD" })
    return result
  },

  download(config?: NetConfig & { url: string }) {
    if (!config?.url?.length) {
      throw Error("can not found url")
    }
    // 直接下载
    window.open(config.url)
    // todo blob下载,暂时没需求 先搁置后续再发开
    // config.responseType = 'blob'
    // const { body } = await request.preSend({ url, ...config })
    // return downBlob(body)
  },

  async put<T = any>(
    url: string,
    config?: NetConfig & {
      fileList?: any[]
      formData?: any
    }
  ): Promise<NetResult<T>> {
    const result = await request.preSend({ url, ...config, method: "PUT" })
    return result
  },

  async delete<T = any>(
    url: string,
    config?: NetConfig
  ): Promise<NetResult<T>> {
    const result = await request.preSend({ url, ...config, method: "DELETE" })
    return result
  },
  /**
   * 网关请求
   * @param serviceCode
   * @param _params
   * @param isGetway
   * @returns
   */
  serviceCall(serviceCode, _params, isGetway, getAll) {
    return new Promise(async (resolve, reject) => {
      if (!serviceCallCfgFn?.length) {
        reject("please INIT serviceCall config")
        return
      }
      const configFn = serviceCallCfgFn.find((fn) => fn(serviceCode)?.params)
      if (typeof configFn !== "function") {
        reject(serviceCode + " function not found")
        return
      }
      const { params: services, ...args } = configFn!(serviceCode)
      if (!services) {
        reject(serviceCode + " not found")
        return
      }
      const options = typeof isGetway === "object" ? isGetway : {}
      const result = await request.getway(
        services,
        serviceCode,
        _params,
        {
          ...args,
          isGetway,
          getAll,
          serviceCallEnv,
          ...options,
        },
        migrateConfig
      )
      resolve(result)
    })
  },
  listener(fn, config) {
    let rateTime =
      config?.rateTime !== undefined
        ? Math.floor(Math.abs(config?.rateTime))
        : 5
    rateTime = rateTime < 0 ? 1 : rateTime
    netListener.init(fn, {
      rateTime: rateTime * 1000,
      speed: config?.speed,
    })
  },
  removeListener() {
    netListener.off()
  },
  enableCache(param) {
    return false
  },
} as NetDSL
